import { createReducer } from '@reduxjs/toolkit';
import { State, RequestError } from 'types';
import { clearStateSlice } from '../clear-slice/actions';
import { updateCompensationSentence, updatedCompensationSentence } from './actions';

export const INITIAL_STATE: State = {
  status: undefined,
  error: undefined,
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<State>(INITIAL_STATE, (builder) =>
  builder
    .addCase(updateCompensationSentence, (state) => {
      state.status = 'loading';
    })
    .addCase(updatedCompensationSentence, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
      } else {
        state.error = undefined;
        state.status = 'success';
      }
    })

    .addCase(clearStateSlice, (state, action) => {
      const { payload } = action;
      if (payload?.sliceReducer === 'CompensationSentence') {
        if (payload?.sliceKey) {
          return {
            ...state,
            [payload.sliceKey]: INITIAL_STATE[payload.sliceKey],
          };
        } else {
          return INITIAL_STATE;
        }
      }
      return state;
    })
);
